import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

const ForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  const handleSendOTP = async (e) => {
    e.preventDefault();
    setMessage("");

    if (!email.trim()) {
      setMessage("Please enter your email address.");
      return;
    }

    try {
      await axios.post(`${API_BASE}/api/user/send-reset-otp`, { email });
      localStorage.setItem("resetEmail", email);
      setMessage("We’ve sent a verification code to your email.");
      setTimeout(() => navigate("/reset-password"), 900);
    } catch (err) {
      console.error("❌ send-reset-otp error:", err);
      setMessage("Unable to send reset code. Please try again.");
    }
  };

  return (
    <div className="min-h-screen bg-white px-6 py-12">
      <div className="max-w-md mx-auto space-y-6">
        <div>
          <h2 className="text-2xl font-semibold text-gray-800">
            Forgot your password?
          </h2>
          <p className="text-sm text-gray-500 mt-1">
            Enter your email and we’ll send a reset code
          </p>
        </div>

        <form onSubmit={handleSendOTP} className="space-y-4">
          <input
            type="email"
            placeholder="Email address"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            className="w-full px-4 py-3 rounded-full border border-gray-200 bg-white text-gray-800 placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-indigo-500"
          />

          <button
            type="submit"
            className="w-full py-3 rounded-full font-semibold text-white bg-gradient-to-r from-indigo-600 via-purple-600 to-pink-600 hover:opacity-90 active:scale-95 transition"
          >
            Send reset code
          </button>
        </form>

        {message && <p className="text-sm text-red-500 text-center">{message}</p>}

        <button
          onClick={() => navigate("/login")}
          className="w-full text-sm text-indigo-600 font-medium hover:underline mt-2"
        >
          Back to login
        </button>
      </div>
    </div>
  );
};

export default ForgotPassword;
